import axios from './_inveAxios'

export const getAsSelect = (tipo, otrosFiltros, flagPorSede) =>
  axios.get('/tablas-personalizadas', {
    params: { tipo, tipoConsulta: 'select', filtros: otrosFiltros, nivelConsulta: flagPorSede ? 'sede' : '' }
  })
